export default "__VITE_ASSET__BKxmQcuU__"